import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { likePost, unlikePost } from "../../redux/actions/postActions";
import formatCount from "../../utils/formatCount";
import { IonButton, IonIcon } from "@ionic/react";
import { heart, heartOutline } from "ionicons/icons";
function LikeBtn({ id, likes }) {
  const { data } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();
  const [liked, setLiked] = useState(false);
  const [likedCount, setLikedCount] = useState(likes.length);
  useEffect(() => {
    // Sync local state with props on load or update
    const isLiked = likes.some((like) => like._id === data._id);
    setLiked(isLiked);
    setLikedCount(likes.length);
  }, [likes, data._id]);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    // Optimistic update
    setLiked((prev) => !prev);

    if (liked) {
      dispatch(unlikePost(id));
      setLikedCount((prev) => prev - 1);
    } else {
      dispatch(likePost(id));
      setLikedCount((prev) => prev + 1);
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <IonButton
        fill="clear"
        size="small"
        shape="round"
        onClick={handleClick}
        className={`sidebar-icon post-btns__btn no-padding-btn ${
          liked ? "" : "post-btns__like"
        }`}
      >
        <IonIcon
          slot="start"
          icon={liked ? heart : heart}
          className={liked ? "heart-red" : ""}
          style={{
            width: "32px",
            height: "32px",
            marginRight: "6px",
            color: liked ? "#d80621" : "rgba(255, 255, 255, 0.9)",
          }}
        />
      </IonButton>
      <p>{formatCount(likedCount)}</p>
    </div>
  );
}

export default LikeBtn;
